
    import { Component, Prop, Vue } from 'vue-property-decorator';
    import { mapActions, mapGetters, mapState } from 'vuex';
    import ElgaPatient from '@/types/soap/elga/Patient';
    import Patient from '@/types/Patient';
    import { confirmSwal } from '@/helper/swals';
    import Land from '@/types/Land';
    import { SystemEinstellung, SystemEinstellungKey } from '@/types/Einstellung';

    @Component({
        computed: {
            ...mapState('globals', ['formatDate']),
            ...mapState('patient', ['patientData', 'loaders']),
            ...mapState('laender', ['laender']),
            ...mapGetters('authentication', ['getSystemEinstellung']),
        },
        methods: {
            ...mapActions('patient', ['saveImpfpass']),
        },
    })
    export default class ElgaPatientDetail extends Vue {
        @Prop() visible!: boolean;
        @Prop() patient!: ElgaPatient;

        public patientData!: Patient;
        public laender!: Land[];
        public saveImpfpass!: (payload: { patient: Patient }) => void;
        public getSystemEinstellung!: <T>(parameter: SystemEinstellungKey) => SystemEinstellung<T>;

        public get patientExists(): boolean {
            return !!this.patient.bPK || !!this.patientData?.bpk_gh;
        }

        public onClickSync(isAdresseUebernehmen: boolean): void {
            const adresseUebernehmen = this.getSystemEinstellung('eimpfpass_adresse_uebernehmen').isEnabled();
            const und = adresseUebernehmen && isAdresseUebernehmen ? ' und die Adresse wird übernommen' : '';

            confirmSwal(
                'e-Impfpass',
                `Der Impfpass von ${this.patient.nachnameVorname} wird für Patient` +
                    ` ${this.patientData.name} importiert${und}. Sind Sie sicher?`,
                'Importieren',
                'Abbrechen',
            ).then(({ isConfirmed }) => {
                if (isConfirmed) {
                    if (this.patient.bPK) {
                        this.patientData.bpk_gh = this.patient.bPK;
                    }

                    if (adresseUebernehmen && isAdresseUebernehmen) {
                        this.patientData.ort = this.patient.city?.slice(0, 50) ?? null;
                        this.patientData.plz = this.patient.postalcode?.slice(0, 8) ?? null;
                        this.patientData.strasse = this.patient.address?.slice(0, 50) ?? null;

                        const land = this.laender.find((land) => land.land === this.patient.country);
                        if (land) {
                            this.patientData.land = land.land;
                            this.patientData.land_bezeichnung = land.bezeichnung;
                        }
                    }

                    this.saveImpfpass({ patient: this.patientData });
                }
            });
        }
    }
